import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ClaycoSecureApp}  from 'clayco-carbon10/dist/index.umd';
import { Provider } from 'react-redux';
import configureStore from './redux/configureStore';
import { msalConfig, b2cMsalConfig, b2cProdConfig } from './msal-config';

const store = configureStore();

ReactDOM.render(
    <Provider store={store}>
      <ClaycoSecureApp authConfig={msalConfig} >
        <App />
      </ClaycoSecureApp>
    </Provider>
  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
